var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseEntrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.611 8.709C23.8561 8.89821 23.9998 9.19032 24 9.5V23C24 23.5523 23.5523 24 23 24H15C14.4477 24 14 23.5523 14 23V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18V23C10 23.5523 9.55228 24 9 24H1C0.447716 24 0 23.5523 0 23V9.5C0.00019455 9.19032 0.143852 8.89821 0.389 8.709L11.389 0.209C11.749 -0.0688286 12.251 -0.0688286 12.611 0.209L23.611 8.709ZM21.5 22C21.7761 22 22 21.7761 22 21.5V10.236C22.0014 10.0797 21.9296 9.93167 21.806 9.836L12.306 2.495C12.1258 2.35557 11.8742 2.35557 11.694 2.495L2.194 9.836C2.07036 9.93167 1.99858 10.0797 2 10.236V21.5C2 21.7761 2.22386 22 2.5 22H7.5C7.77615 22 8 21.7761 8 21.5V18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18V21.5C16 21.7761 16.2239 22 16.5 22H21.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseEntrance);
export default __webpack_public_path__ + "static/media/houseEntrance.0fb4f44a.svg";
export { ForwardRef as ReactComponent };